import SectionHeading from "@/components/base/SectionHeading";
import { storyArcs } from "@/mocks/comicData";

export default function StoryArcs() {
  return (
    <section id="arcs" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionHeading
          eyebrow="剧情看点"
          title="关系发展的四个阶段"
          description="继母、继姐与主角的关系并非一蹴而就。按剧情推进，梳理四个关键节点，让你快速掌握情感升温的节奏。"
        />

        <div className="relative mt-10 grid gap-6 md:mt-16 md:grid-cols-4">
          <span className="absolute left-0 right-0 top-6 hidden h-0.5 bg-gradient-to-r from-accent-300 via-primary-300 to-secondary-300 md:block"></span>
          {storyArcs.map((arc, index) => (
            <article
              key={arc.step}
              className="relative flex flex-col gap-3 rounded-2xl border border-background-200/80 bg-background-50 p-6"
            >
              <span className="relative z-10 grid h-12 w-12 place-items-center rounded-full bg-accent-500 font-heading text-lg font-black text-background-50">
                {arc.step}
              </span>
              <div className="mt-2">
                <span className="text-xs font-medium text-accent-700">{arc.keyword}</span>
                <h3 className="mt-1 font-heading text-lg font-bold text-foreground-950">
                  {arc.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                  {arc.description}
                </p>
              </div>
              {index < storyArcs.length - 1 && (
                <span className="absolute right-4 top-1/2 hidden h-4 w-4 -translate-y-1/2 items-center justify-center md:grid">
                  <i className="ri-arrow-right-s-line text-primary-400"></i>
                </span>
              )}
            </article>
          ))}
        </div>

        <p className="mt-8 text-center font-heading text-base md:text-lg font-semibold text-primary-700">
          从「陌生的屋檐」到「成为一家人」，每一段关系都有它值得被记住的模样。
        </p>
      </div>
    </section>
  );
}